//九阳股份
import Overview from './overview.vue';

export const componentMap = {
    overview: Overview
};